import { render, staticRenderFns } from "./BladeFooter.vue?vue&type=template&id=488ef03d&scoped=true&"
import script from "./BladeFooter.vue?vue&type=script&lang=ts&"
export * from "./BladeFooter.vue?vue&type=script&lang=ts&"
import style0 from "./BladeFooter.vue?vue&type=style&index=0&id=488ef03d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ef03d",
  null
  
)

export default component.exports